import { UserActionName } from './user-action';

const enum ActivityDetailType {
    Document = 0,
    Study = 1,
    Site = 2,
    StudySite = 3
}

export class ActivityDocumentDetail {
    public readonly detailType = ActivityDetailType.Document;
    constructor(
        public readonly documentId: string,
    ) {}
}

export class ActivityStudyDetail {
    public readonly detailType = ActivityDetailType.Study;
    constructor(
        public readonly protocolId: number,
    ) {}
}

export class ActivitySiteDetail {
    public readonly detailType = ActivityDetailType.Site;
    constructor(
        public readonly siteId: number,
    ) {}
}

export class ActivityStudySiteDetail {
    public readonly detailType = ActivityDetailType.StudySite;
    constructor(
        public readonly protocolId: number,
        public readonly siteId: number,
    ) {}
}

export type ActivityDetailData =
    | ActivityDocumentDetail
    | ActivityStudyDetail
    | ActivitySiteDetail
    | ActivityStudySiteDetail
    ;

const enum ActivityDataType {
    Default = 0,
    Detailed = 1
}

export class DefaultActivityData {
    public readonly activityType = ActivityDataType.Default;
    constructor(
        public readonly userAction: UserActionName,
        public readonly userSessionId: string,
    ) {}
}

export class DetailedActivityData {
    public readonly activityType = ActivityDataType.Detailed;
    constructor(
        public readonly userAction: UserActionName,
        public readonly userSessionId: string,
        public readonly details: ActivityDetailData[],
    ) {}
}

export type ActivityData =
    | DefaultActivityData
    | DetailedActivityData
    ;